import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, Divider,
    List,
    ListItem, ListItemIcon, ListItemText
} from "@material-ui/core"
import moment from "moment"
import { Spacer } from "../../components/spacer"
import { useRedirect } from "react-admin"
import {
  QuizAssessmentTestGradeComponent
} from "../../resources/quiz-assessment-availability/component/quiz-assessment-test-grade.component";
import InfoIcon from "@material-ui/icons/Info";
import CheckIcon from "@material-ui/icons/Check";
import {AssessmentOutlined, Timer} from "@material-ui/icons";

const TestFinishModal = ({
  finishedByAnswers,
  finishedByTimeout,
  submitting,
  evaluateData,
}) => {

    const redirect = useRedirect()

    return (
        <Dialog open={finishedByAnswers || finishedByTimeout} maxWidth={'xs'} fullWidth>
            <DialogTitle>
                {!evaluateData && finishedByAnswers && "Você finalizou a avaliação!"}
                {!evaluateData && finishedByTimeout && "Seu tempo acabou. A avaliação foi encerrada automaticamente pelo sistema."}
                {evaluateData && "Resultado"}
            </DialogTitle>

            <Divider />
            {
                !evaluateData && finishedByTimeout && <DialogContent>
                    <DialogContentText>{"O tempo estipulado para a resolução da avaliação foi encerrado."}</DialogContentText>
                </DialogContent>
            }
            {
                !evaluateData && submitting && <DialogContent>
                    <DialogContentText>{"Aguarde enquanto enviamos as questões para correção."}</DialogContentText>
                </DialogContent>
            }
            {evaluateData && (
                <List>
                    <ListItem>
                        <ListItemIcon>
                            <InfoIcon />
                        </ListItemIcon>
                        <ListItemText
                            primary={'Total de Questões'}
                            secondary={evaluateData.totalQuestions}
                        />
                    </ListItem>

                    <Divider />
                    <ListItem>
                        <ListItemIcon>
                            <CheckIcon />
                        </ListItemIcon>
                        <ListItemText
                            primary={'Total de Acertos'}
                            secondary={evaluateData.correctAnswers}
                        />
                    </ListItem>
                    <Divider />
                    <ListItem>
                        <ListItemIcon>
                            <AssessmentOutlined />
                        </ListItemIcon>

                        <ListItemText
                            primary={'Nota Final'}
                            secondary={<QuizAssessmentTestGradeComponent {...evaluateData} />} />
                    </ListItem>
                    <Divider />
                    <ListItem>
                        <ListItemIcon>
                            <Timer />
                        </ListItemIcon>
                        <ListItemText
                            primary={'Tempo Utilizado'}
                            secondary={moment.duration(moment(evaluateData.finishedAt).diff(moment(evaluateData.startedAt))).asMinutes().toFixed(0)}
                        />
                    </ListItem>
                </List>

                // <DialogContent>
                //     <DialogContentText>{`Questões respondidas: ${evaluateData.totalQuestions}`}</DialogContentText>
                //     <DialogContentText>{`Acertos: ${evaluateData.correctAnswers}`}</DialogContentText>
                //     <DialogContentText>Nota Final: <QuizAssessmentTestGradeComponent {...evaluateData} /></DialogContentText>
                //
                //     <DialogContentText>{`Tempo utilizado: ${moment.duration(moment(evaluateData.finishedAt).diff(moment(evaluateData.startedAt))).asMinutes().toFixed(0)} minutos`}</DialogContentText>
                // </DialogContent>
                )
            }
            <DialogActions>
                <Spacer />
                <Button
                    onClick={() => { redirect('/') }}
                    variant="text"
                    disabled={!evaluateData && submitting}
                >
                    {"Voltar à página inicial"}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default TestFinishModal